/* global Util */
import { push } from '@/js/data-layer';
import { setCookie, getCookie, COOKIE_CONSENT_NAME, COOKIE_CONSENT_VALUE } from '@/js/utils/cookie';

(() => {
  const cookieBannerElm = document.querySelector('.js-cookie-banner .js-notice');
  const cookieConsentGiven = getCookie(COOKIE_CONSENT_NAME) === COOKIE_CONSENT_VALUE;
  const cookieBodyClass = 'cookie-consent-not-given';

  if (cookieConsentGiven) {
    push({ event: COOKIE_CONSENT_NAME });
  } else if (!cookieConsentGiven && cookieBannerElm) {
    Util.addClass(document.body, cookieBodyClass);

    // @see https://www.metric.ai/blog/gdpr-cookies/
    cookieBannerElm.addEventListener('hideNotice', () => {
      setCookie(COOKIE_CONSENT_NAME, COOKIE_CONSENT_VALUE, 60);
      push({ event: COOKIE_CONSENT_NAME });
      Util.removeClass(document.body, cookieBodyClass);
    });
  }
})();
